import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import { NitroButton } from "nitro-components";

import Container from "../../../components/layouts/Container";

const NavBarContainer = styled.div`
  position: fixed;
  bottom: 0;
  box-shadow: ${props => props.theme.boxShadow["2"]};

  background-color: ${props => props.theme.color.white};
  height: 70px;
  left: 0;
  right: 0;
`;

const NavContent = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Section = styled.div`
  flex: 1;
  display: flex;
`;

const LeftSection = Section.extend`justify-content: flex-start;`;
const MiddleSection = Section.extend`justify-content: center;`;
const RightSection = Section.extend`justify-content: flex-end;`;

const NavBar = ({ navigation, navigationComponent }) => {
  console.log(navigation);
  console.log(navigationComponent);
  const { goNext, goPrevious, currentStep } = navigation;
  const { left, middle, right } = navigationComponent;
  return (
    <NavBarContainer>
      <Container>
        <NavContent>
          <LeftSection>
            {left}
          </LeftSection>
          <MiddleSection>
            {middle}
          </MiddleSection>
          <RightSection>
            {right}
          </RightSection>
        </NavContent>
      </Container>
    </NavBarContainer>
  );
};

// const NavBar = ({ left, middle, right }) => {
//   return (
//     <NavBarContainer>
//       <Container>
//         <NavContent>
//           <LeftSection>
//             {left}
//           </LeftSection>
//           <MiddleSection>
//             {middle}
//           </MiddleSection>
//           <RightSection>
//             {right}
//           </RightSection>
//         </NavContent>
//       </Container>
//     </NavBarContainer>
//   );
// };

NavBar.propTypes = {
  navigation: PropTypes.object,
  navigationComponent: PropTypes.object
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/NavBar.js